import {
  createSnowplowClient,
  type SnowplowClient,
  type SnowplowSdkConfig,
} from '@nextmar/snowplow-sdk';
import { createAppInitializingClient } from './appClient';

/** SDK Client 工厂签名；测试可注入无副作用替身。 */
type SnowplowClientFactory = (config: SnowplowSdkConfig) => SnowplowClient;

/** 页面生命周期内唯一的 Z Snowplow SDK Client。 */
let zeeloolSnowplowClient: SnowplowClient | null = null;

/** 默认使用 SDK 根入口工厂，测试 reset 时可显式替换。 */
let snowplowClientFactory: SnowplowClientFactory = createSnowplowClient;

/** 按首次显式配置创建 Z Client；重复配置始终复用已有实例且不会调用 init。 */
export function configureZeeloolSnowplowClient(config: SnowplowSdkConfig): SnowplowClient {
  if (!zeeloolSnowplowClient) {
    const actual = snowplowClientFactory(config);
    zeeloolSnowplowClient =
      config.runtime === 'webview' ? createAppInitializingClient(actual) : actual;
  }

  return zeeloolSnowplowClient;
}

/** 返回已配置的 Z Client；初始化入口尚未执行时返回 null。 */
export function getZeeloolSnowplowClient(): SnowplowClient | null {
  return zeeloolSnowplowClient;
}

/** 仅供同目录单测隔离 singleton；应用公共 barrel 不导出此方法。 */
export function resetZeeloolSnowplowClientForTests(
  factory: SnowplowClientFactory = createSnowplowClient,
): void {
  zeeloolSnowplowClient = null;
  snowplowClientFactory = factory;
}
